import Dexie, { type Table } from 'dexie';
import { ref } from 'vue';
import stores from '@ganaderia/stores';

export interface DexieSync {
  id?: number;
  method: string;
  url: string;
  payload?: any;
  action?: string;
  number?: string;
  farm?: number;
  timestamp?: string;
  message?: string;
  synced?: boolean;
  syncing?: boolean;
  syncError?: boolean;
  errorMessage?: string;
  offlineAddedId?: number;
}

class GanaderiaDexie extends Dexie {
  cows!: Table<any, number>;
  milks!: Table<any, number>;
  syncs!: Table<DexieSync, number>;

  constructor() {
    super('ganaderia');
    this.version(4).stores({
      cows:
        '++id, birthDate, color, number, farm, fertility, iron, mother_id, mother_number, observation, pregnancyDate, race, selected, female, status, abortions, revisions',
      milks: '++id, cows, day, liter, price, priceLiter',
      syncs: '++id, action, number, farm, timestamp, message, method, url, payload, offlineAddedId'
    });
  }
}

export const db = new GanaderiaDexie();

const online = ref(navigator.onLine);

export default () => {
  const updateSyncLength = async () => {
    const count = await db.syncs.count();
    stores.offline.state.openSyncs.value = count;
  };

  const dbUpdateAllSelected = async (allSelected: { id: number }[]) => {
    const ids = allSelected.map((c) => c.id);
    const cows = await db.cows.toArray();
    for (const cow of cows) {
      await db.cows.update(cow.id, { selected: ids.includes(cow.id) });
    }
  };

  const updateOnlineStatus = () => {
    online.value = navigator.onLine;
    stores.offline.state.online.value = navigator.onLine;
  };

  return { db, online, updateSyncLength, dbUpdateAllSelected, updateOnlineStatus };
};
